<article role="article" class="card-job" [class.card-job--visited]="isVisited$ | async">
  <div class="card-job__logo">
    <img
      *ngIf="job.origineOffre.origine === PoleEmploiJobOrigine.Un"
      src="/assets/images/pole-emploi.svg"
      alt="Logo de Pole Emploi"
    />
    <img
      *ngIf="
        job.origineOffre.origine === PoleEmploiJobOrigine.Deux || job.origineOffre.origine === PoleEmploiJobOrigine.AO
      "
      [src]="job.origineOffre.partenaires[0].logo"
      [alt]="'Logo de ' + job.origineOffre.partenaires[0].nom"
    />
  </div>

  <div class="card-job__right">
    <div class="card-job__content">
      <div class="content__infos">
        <h3 role="heading" class="content__infos__title" *ngIf="job?.intitule">{{ job.intitule }}</h3>
        <p class="content__infos__company" *ngIf="job?.entreprise?.nom">{{ job.entreprise.nom }}</p>
        <p class="content__infos__date" *ngIf="job?.dateCreation">
          Publié le {{ job.dateCreation | date: 'dd/MM/yy' }}
        </p>
      </div>

      <ul class="content__tags">
        <li *ngIf="job?.lieuTravail?.libelle">
          <app-chip
            ><mat-icon class="icon icon--location" matPrefix svgIcon="pin" role="presentation"></mat-icon>
            {{ job.lieuTravail.libelle }}
          </app-chip>
        </li>
        <li *ngIf="job?.typeContrat">
          <app-chip
            ><mat-icon class="icon icon--briefcase" matPrefix svgIcon="briefcase" role="presentation"></mat-icon>
            {{ job.typeContrat | typeContrat }}
          </app-chip>
        </li>
        <li *ngIf="job?.dureeTravailLibelleConverti && origin !== PoleEmploiOrigin.STUDENT_JOB">
          <app-chip
            ><mat-icon class="icon icon--clock" matPrefix svgIcon="clock" role="presentation"></mat-icon>
            {{ job.dureeTravailLibelleConverti }}
          </app-chip>
        </li>
        <li *ngIf="job?.dureeTravailLibelle && origin === PoleEmploiOrigin.STUDENT_JOB">
          <app-chip
            ><mat-icon class="icon icon--clock" matPrefix svgIcon="clock" role="presentation"></mat-icon>
            {{ job.dureeTravailLibelle }}
          </app-chip>
        </li>
      </ul>
    </div>

    <a
      *ngIf="(routerLink$ | async)?.length > 0"
      [id]="elm_id"
      class="card-job__button btn-clean btn"
      [routerLink]="routerLink$ | async"
      [state]="{ queryParams: route.queryParams | async }"
      [attr.aria-label]="'Consulter l\'offre d\'emploi ' + job?.intitule"
      (click)="
        trackEvent({
          category: trackEventCategory,
          action: 'Click Offre',
          label: job.typeContrat + ' - ' + job.lieuTravail.libelle,
          type: 'navigation'
        })
      "
      >Consulter l&apos;offre</a
    >
  </div>
</article>
